/*
 * @Author: your name
 * @Date: 2020-05-26 19:40:04
 * @LastEditTime: 2020-06-23 18:15:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \client-v4\src\api\favor.js
 */
/**
 * auth模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../request/http'; // 导入http中创建的axios实例
// import qs from 'qs'; // 根据需求是否导入qs模块
import store from '../store';

const favor = {
    //获取收藏产品  {{url}}/acheteur/produits/
    getPList(params) {
        return axios.get(base.dev + '/acheteur/produits', {params: params});
    },
    //获取买家收藏的产品分类
    get_favorite_prod_categories(params) {
        return axios.get(base.dev + '/v2/acheteurs/get_favorite_prod_categories', {params: params});
    },
    //获取收藏商家
    goodMarques(para) {
        // {{url}}/vendeurs/90/marques
        return axios.get(base.dev + '/acheteur/' + para.id_acheteur + '/vendeur');
    },
    //添加浏览历史记录
    recordHistory(query) {
        if (!store.state.token) return new Promise(resolve => {
        });
        return axios.post(base.dev + '/v2/browserHistory/recordHistory', query);
    },
    //获取浏览历史记录
    getHistory(query) {
        return axios.get(base.dev + '/v2/browserHistory/getHistory', {params: query});
    },

    //添加收藏商家
    addSellerMarques(param) {
        // {{url}}/vendeurs/90/marques
        return axios.post(base.dev + '/v2/acheteurs/add_seller_marques_collection', param);
    },

    //添加收藏产品
    addFavorProduit(params) {
        return axios.post(base.dev + '/acheteur/produits/' + params.id_produit);
    }
}

export default favor;
